<template>
  <div class="account-wrapper flex flex-col h-full w-full">
    <div
      class="account-select flex-1 flex flex-col overflow-auto"
      :class="{
        'mb-[30px]': !userInfo?.user_id,
      }"
    >
      <div v-if="userInfo?.user_id">
        <div class="title">{{ $t('dang-qian-zhang-hao') }}</div>
        <div class="account-list">
          <div
            :key="userInfo.user_id"
            class="account-list-item account-list-item-selected cursor-auto"
          >
            <UserItem :data="userInfo" />
          </div>
        </div>
      </div>
      <!-- <a-spin :spinning="loading" class="h-full"> -->
      <div class="title">
        {{
          userInfo?.user_id ? $t('qi-ta-zhang-hao') : $t('quan-bu-zhang-hao')
        }}
      </div>
      <div
        class="overflow-auto flex-1"
        :style="otherAccount?.length > MAX_NUM ? 'margin-inline-end: -4px' : ''"
      >
        <div class="account-list overflow-auto">
          <div
            v-for="item in otherAccount"
            :key="item.user_id"
            class="account-list-item"
            :class="{
              'opacity-30': !item?.is_active_user,
            }"
            @click="onSelectAccount(item)"
          >
            <a-popover v-if="!item?.is_active_user">
              <template #content>
                {{
                  $t(
                    'tuan-dui-xi-wei-bu-zu-nin-de-zhang-hao-zan-shi-wu-fa-deng-lu-qing-lian-xi-guan-li-yuan-jin-hang-xi-wei-jia-gou'
                  )
                }}
              </template>
              <UserItem :data="item" class="cursor-not-allowed" />
            </a-popover>
            <UserItem v-else :data="item" />
          </div>
        </div>
      </div>
      <!-- </a-spin> -->
    </div>
    <CreateTasteCheck
      v-if="userInfo?.user_id && hasActionPermission('create_try_team')"
      @cancel="showAccountType = null"
    >
      <CreateTeamBtn type="dashed" class="mx-[20px]" />
    </CreateTasteCheck>
    <div v-if="userInfo?.user_id" class="account-footer">
      <a @click="goLogin">
        {{
          !isGlobalVersion()
            ? $t('shi-yong-qi-ta-shou-ji-hao-huo-zhang-hao-deng-lu')
            : $t('shi-yong-qi-ta-you-xiang-deng-lu')
        }}
        >
      </a>
    </div>
  </div>
</template>

<script lang="ts" setup>
import UserItem from './userItem.vue'
import { getUserInfo, getUserToken, loginForWeb, setUserLog } from '@/api'
import { useSession } from '~/composables/user'
import { type LoginInfo } from '~/api/interface/auth'
import { USER_ADMIN } from '~/constants'
import CreateTasteCheck from '~/features/createTasteCheck/index.vue'
import { BROADCAST_KEY, COOKIE_KEY } from '~/constants/config'
const { $t } = useNuxtApp()
const { hasActionPermission } = usePageAndActionPermissionData()

const userInfo = useUserInfo()
const accountList = useAccountList()
const session = useSession()
const showAccountType = useAccountType()
const MAX_NUM = 6
const loading = ref(false)

const emit = defineEmits(['select', 'gotoLogin'])

const otherAccount = computed(() =>
  accountList.value.filter((o) => o.user_id !== userInfo.value?.user_id)
)

// 退出登录
const goLogin = async () => {
  trackEvent(TRACK_EVENT.LOGIN_OUT_CLICK)
  await useLoginOut()
  // emitBroadcast(COOKIE_KEY.USER_TOKEN, {
  //   cookieValue: undefined,
  // })
  emitBroadcast(BROADCAST_KEY.REFRESH, { tabId: TAB_ID })
  emit('gotoLogin')
}

const onSelectAccount = async (item: LoginInfo) => {
  const { user_id, is_active_user } = item

  if (!is_active_user) {
    return
  }
  let account = accountList.value.find((o) => o.user_id === user_id)
  if (!account) {
    return
  }

  if (account?.is_expired && account.permission === USER_ADMIN.NORMAL) {
    return message.error($t('tao-can-yi-guo-qi'))
  }

  try {
    loading.value = true
    if (!session.value?.user_id) {
      session.value = account
      setUserLog()
      const result = await getUserInfo()
      loading.value = false
      updateCustomSetting(result.data)
      userInfo.value = result.data
      sensorsLogin(Number(result.data?.user_id))
    } else {
      const { data } = await getUserToken(account.user_id)
      loading.value = false
      sensorsLogin(Number(account.user_id))
      account = data?.[0]
      session.value = account
      updateCustomSetting(account)
    }

    if (session.value) {
      // 如果依赖于下面的通知登录态，可能会出现外面页面以为登录成功触发刷新跳转，导致下面消息没有发出，最终导致登录态没有植入的问题
      await loginForWeb(session.value)
    }

    // emitBroadcast(COOKIE_KEY.USER_TOKEN, {
    //   cookieValue: JSON.parse(JSON.stringify(session.value)),
    // })
    emitBroadcast(BROADCAST_KEY.REFRESH, { tabId: TAB_ID })

    emit('select', session.value)
  } catch (error) {
    console.log(error)
    loading.value = false
  }
}

function updateCustomSetting(userInfo: any) {
  CustomSettingApp.initAvatar(userInfo.logo_url, userInfo.default_logo_url)
  CustomSettingApp.initLogo(
    userInfo.platform_logo_url,
    userInfo.default_platform_logo_url
  )
}

const initAccount = async () => {
  await useUpdateAccountList()
}

watch(
  () => showAccountType.value,
  (val) => {
    if (val === 'select') {
      initAccount()
    }
  },
  { immediate: true }
)
</script>

<style lang="scss" scoped>
.account-select {
  @apply px-[20px] mt-[20px];
  .title {
    @apply mt-[8px] mb-[10px] text-14 text-font-1 ml-[15px] font-medium;
  }
  .tags {
    @apply h-[22px] pb-[1px];
    min-width: 60px;
  }
}
.account-footer {
  @apply pt-[12px] pb-[16px] flex-y-center justify-center;
  // border-top: 1px solid var(--back-4);
}
.account-list {
  @apply bottom-0 p-0 outline-none leading-[0] m-0;

  .avatar {
    @apply w-[34px] h-[34px];
  }
  // &.ant-menu-light.ant-menu-root.ant-menu-vertical {
  //   border-inline-end: none;
  // }

  .account-list-item {
    @apply rounded-[8px];
    cursor: pointer;
    padding-left: 16px;
    padding-right: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 4px;
    width: calc(100% - 8px);
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    height: 44px;
    line-height: 44px;

    &.account-list-item-selected {
      background-color: var(--back-2);
      color: var(--purple-6);
    }

    &:hover {
      background: var(--back-2);
    }
  }
}
</style>
